// Mutates in place and hands the same reference back, so the generic keeps the
// caller's type (e.g. AfriexRates[]) instead of widening it.
export function removeUndefinedKeys<T>(obj: T): T {
  // `for..in` over a non-object is a no-op, so this guard only narrows the type.
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  const record = obj as Record<string, unknown>;
  for (const key in record) {
    if (record[key] !== null && typeof record[key] === 'object') {
      // Recursively call removeUndefinedKeys for nested objects
      removeUndefinedKeys(record[key]);
    }
    if (key === 'undefined') {
      delete record[key]; // Remove key if it is 'undefined'
    }
  }
  return obj;
}
